import { IEnum } from '@common/types';
import { isArray, isEmpty } from 'lodash';

export const restrictionToForm = (restriction: IEnum<string> | null) => {
  if (isEmpty(restriction) || isArray(restriction) || !restriction) return [];
  return Object.entries(restriction).map(([value, label]) => {
    return { value, label };
  });
};
